const View = ({ data }) => (
  <div className="sectionSubtitle" style={{ textAlign: data.align }}>
    {data.title}
  </div>
);

export default View;
